
<template>
  <div>
    <div class="form-row div-valign">
      <div class="form-group col-md-6">
        <label>
          เลขที่สัญญา
          <!-- <span class="text-white">PTTGC_2</span> -->
        </label>
        <input
          v-model="ctrNo"
          name="ctrNo"
          data-vv-as="เลขที่สัญญา"
          v-validate="{ required:true}"

          :class="{'input': true, 'is-danger': errors.has('ctrNo') }"
          type="text"
          class="form-control"
        >

        <span v-show="errors.has('ctrNo')" class="help is-danger">{{ errors.first('ctrNo') }}</span>
      </div>
      
      <div class="form-group col-md-6">
        <label>วันที่ลงสัญญา
          <!-- <span class="text-white">PTTGC_2</span> -->
        </label>

        <date-picker
          v-model="ctrDate"
          name="ctrDate"
          ref="ctrDate"
          format="DD/MM/YYYY"
          v-validate="{ required:true}"
          data-vv-as="วันที่ลงสัญญา"
          lang="th"
          :class="{'input': true, 'is-danger': errors.has('ctrDate') }"
          placeholder
        ></date-picker>
        <span v-show="errors.has('ctrDate')" class="help is-danger">{{ errors.first('ctrDate') }}</span>  
        
      </div>

      <div class="form-group col-md-12">
        <label>
          รายละเอียดโครงการ/รายละเอียดสัญญา
          <!-- <span class="text-white">PTTGC_2</span> -->
        </label>
        <input
          v-model="beneficiaryRemark"
          name="beneficiaryRemark"
          data-vv-as="รายละเอียดโครงการ/รายละเอียดสัญญา"
          v-validate="{ required:true}"
          :class="{'input': true, 'is-danger': errors.has('beneficiaryRemark') }"
          type="text"
          class="form-control"
        >

        <span v-show="errors.has('beneficiaryRemark')" class="help is-danger">{{ errors.first('beneficiaryRemark') }}</span>
      </div>
    </div>
  </div>
</template>

<script>
//import DatePicker from "vue2-datepicker";
import DatePicker from "@/resources/datepicker/vue2-datepicker";
import moment from "moment";

export default {
  inject: ["$validator"],
  props: ["reqType","appVo","lgType"],
  components: {
    DatePicker
  },
  data() {
    return {
      ctrNo: "",
      ctrDate: "",
      beneficiaryRemark: ""
      // reqType:this.reqType,
    };
  },
  mounted() {
    // initial ค่ากรณีที่เป็น ต่ออายุและ เพิ่มวงเงิน
    if(this.appVo){
      this.ctrNo = this.appVo.ctrNo;
      this.ctrDate = moment(this.appVo.ctrDate, 'DD/MM/YYYY');
      this.beneficiaryRemark = this.appVo.beneficiaryRemark;
    }
  },    
  watch: {
    ctrNo(newDate, oldDate) {
      this.$emit("childExtToParent", {
        ctrNo: this.ctrNo,
        ctrDate: this.ctrDate,
        beneficiaryRemark: this.beneficiaryRemark
      });
    },
    ctrDate(newDate, oldDate) {
      this.$emit("childExtToParent", {
        ctrNo: this.ctrNo,
        ctrDate: this.ctrDate,
        beneficiaryRemark: this.beneficiaryRemark
      });
    },
    beneficiaryRemark(newDate, oldDate) {
      this.$emit("childExtToParent", {
        ctrNo: this.ctrNo,
        ctrDate: this.ctrDate,
        beneficiaryRemark: this.beneficiaryRemark
      });
    }
  }
};
</script>
                          
